import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import cx from "classnames";
import { Wrapper } from "../../verify.styles";
import { CircleAlert } from "@components/icons";
import SectionHeading from "@components/sectionHeading";
import { VerifyParagraph } from "../../components/VerifyParagraph";
import NextButton from "@components/nextButton";
import Verification from "@components/verification";
import { TRUE_FALSE_VALUES } from "../../../../constants/commonConstants"
import actions from "@redux/verify/actions";
import { useMissingAccountExternalIdRedirect, useAccountExternalId } from "@hooks";

const twoPlusSaccChoice = TRUE_FALSE_VALUES.TRUE;
const createVerifyData = (choice) => ({isAnotherLoanManageable: choice === twoPlusSaccChoice});


export const VerifyTwoPlusSacc = ({meta}) => {
  const { stepName } = meta;
  const accountExternalId = useAccountExternalId();
  const dispatch = useDispatch();
  const { isSubmitting, submitSuccessful } = useSelector(store => store.verify);
  const [value, setValue] = useState(TRUE_FALSE_VALUES.TRUE);
  useMissingAccountExternalIdRedirect();


  const submitPage = () => {
    dispatch(actions.submitVerifyPage({data: createVerifyData(value), stepName, accountExternalId}));
  };

  const onClickTwoPlusSacc = () => {
    if (!isSubmitting) {
      submitPage();
    }
  };

  return (
    <Wrapper className={cx(value, {"is-submitting": isSubmitting})}>
      <CircleAlert className="warning-icon" />
      <SectionHeading heading="Verification required" />
      <VerifyParagraph spacesTop={1} spacesBottom={1}>
        Your bank statements (for the last 90 days) show you are repaying two small personal loans.
      </VerifyParagraph>
      <VerifyParagraph spacesTop={1} spacesBottom={1}>
        <b>Will another loan be manageable for you?</b>
      </VerifyParagraph>

      <Verification
        title={<></>}
        leftButtonProps={{ value: TRUE_FALSE_VALUES.TRUE, checked: value === TRUE_FALSE_VALUES.TRUE, name:"verifyManageableLoan", id:"manageableLoanYes" }}
        leftButtonLabel="Yes"
        rightButtonProps={{ value: TRUE_FALSE_VALUES.FALSE, checked: value === TRUE_FALSE_VALUES.FALSE, name:"verifyManageableLoan", id:"manageableLoanNo" }}
        rightButtonLabel="No"
        onChange={(event) => setValue(event.target.value)}
      /> 
      <NextButton 
        type="button" 
        className="two-plus-sacc-button"
        id="consent-two-plus-sacc"
        disabled={submitSuccessful}
        onClick={onClickTwoPlusSacc} 
        text="Submit" 
        isFetching={isSubmitting}
        name="submitTwoPlusSacc"
      />
    </Wrapper>
  );
};